export default "__VITE_ASSET__62df6da7__"